import { AwardsApi } from '../clients';
import { mapCycle } from '../mappers';

export const updateCycle = async (cycleId, payload) =>
  mapCycle(await AwardsApi.updateCycle(cycleId, payload));
